import { h, Ref } from "vue";
import { useModal } from "vue-final-modal";

import controller from "@ctrl/controller";
import { Controller } from "@ctrl/controller-rpc";

import Modal from "@/components/modals/Modal.vue";
import ModalFatal from "@/components/modals/ModalFatal.vue";

const { applyUpdate } = controller;

export const launchFatalModal = (
  controller: Controller,
  newVersion: Ref<string | undefined>,
  fatalError: Ref<string | null>,
  version: string,
  email: string,
  routineId: string,
  reload: () => void,
  logout: () => Promise<void>
) => {
  const disconnect = () => {
    if (newVersion.value) applyUpdate();
    else logout();
  };
  const { open: openFatalModal } = useModal({
    component: Modal,
    attrs: {
      title: "Fatal error",
      isCancellable: false,
      modalButtons: [
        {
          title: "Log Out",
          kind: "main",
          tint: "red",
          func: async () => {
            disconnect();
          },
        },
        {
          title: newVersion.value ? "Install update" : "Reload",
          kind: "main",
          func: async () => reload(),
        },
      ],
    },
    slots: {
      default: () =>
        h(ModalFatal, {
          newVersion: newVersion.value,
          message: fatalError.value,
          version: version,
          email: email,
          routineId: routineId,
          timestamp: new Date().toISOString(),
        }),
    },
  });

  return {
    openFatalModal,
  };
};
